module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/211-poland-23cf30aee2196a1826c11a7e671e2c48.svg";